export default __webpack_public_path__ + "static/media/cheers-fren.a961aafa.jpeg";